import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.primary_500};
    color: ${({ theme }) => theme.neutral_100};
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const FullScreenScanner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  width: 100dvw;
  height: 100dvh;
  z-index: 4;
  background: ${({ theme }) => theme.neutral_100};
`;

export const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const CameraWrapper = styled.div`
  position: relative;
  width: 400px;
  max-width: 90%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.neutral_300};
  border-radius: 8px;
  overflow: hidden;

  video {
    width: 100%;
    min-height: 500px;
  }
`;

export const ChangeCameraButton = styled.button`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: ${({ theme }) => theme.neutral_300};
  border-top-left-radius: 8px;
  cursor: pointer;
`;

export const CodesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 100%;
  width: 400px;
  max-width: 90%;
  border: 1px solid ${({ theme }) => theme.neutral_300};
  border-radius: 8px;
  padding: 8px;
  gap: 8px;
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: ${({ theme }) => theme.neutral_300};
  border-radius: 4px;
  height: 24px;

  .tag-text {
    padding: 0 8px;
    max-width: 80%;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    text-align: right;
  }
`;

export const RemoveTagButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  cursor: pointer;
  height: 100%;
  padding: 0 4px;
  border-radius: inherit;

  &:hover {
    background-color: ${({ theme }) => theme.danger_500};
    color: ${({ theme }) => theme.neutral_100};
  }
`;
